export const supportRequestListDefaultPayload = (user) => ({
  filters: {
    userId: [{ userId: user?.id, name: `${user?.firstName} ${user?.lastName}` }],
  },
});
